import { computed, watch, ref, onMounted } from 'vue';
import store from '@/store'; // 假设 store 导出路径

/**
 * 可视化参数监听 Hook
 * @param {Function} onLoadCallback - 参数变化时的回调函数
 */
export function useVisualFilter(onLoadCallback) {
    const filterParams = computed(() => store.state.complaint.visualFilter);
    let _timer = null;

    watch(filterParams, (newVal, oldVal) => {
        // 值相等性检查
        if (oldVal && JSON.stringify(newVal) === JSON.stringify(oldVal)) {
            return;
        }

        if (_timer) clearTimeout(_timer);

        _timer = setTimeout(() => {
            if (typeof onLoadCallback === 'function') {
                onLoadCallback();
            }
            _timer = null;
        }, 50);
    }, { deep: true, immediate: true });

    return {
        filterParams
    };
}
